module.exports = __webpack_public_path__ + "media/tutoring/rath-tutoring-approach-08b8735e.svg";